const DEFAULT_REGION = "na1";
const DEFAULT_PORTALID = "22370777";

class HubspotForm {
  /**
   * @type {HTMLElement}
   */
  base;

  /**
   * @type {string}
   */
  portalID;
  /**
   * @type {string}
   */
  region;
  /**
   * @type {string}
   */
  formID;

  /**
   * @type {HTMLIFrameElement}
   */
  frame;

  constructor($base) {
    this.base = $base;

    this.region = this.base.dataset.region || DEFAULT_REGION;
    this.portalID = this.base.dataset.portalid || DEFAULT_PORTALID;
    this.formID = this.base.dataset.formid;

    // bind functions
    this.onFormReady = this.onFormReady.bind(this);

    this.init();
  }

  onFormReady() {
    this.frame = this.base.querySelector("iframe");
    if (this.frame) {
      const frameHeight = this.frame.getBoundingClientRect().height + 24;
      this.frame.style.height = `${frameHeight}px`;
      this.base.style.height = `${frameHeight}px`;
      setTimeout(() => {
        this.frame.setAttribute("height", frameHeight);
        this.frame.style.height = `${frameHeight}px`;
        this.base.style.height = `auto`;
      }, 401);
    } else {
      this.base.style.height = `auto`;
    }
  }

  init() {
    if (typeof window.hbspt !== "undefined" && this.formID && this.base.id) {
      hbspt.forms.create({
        region: this.region,
        portalId: this.portalID,
        formId: this.formID,
        target: `#${this.base.id}`,
        onFormReady: this.onFormReady,
      });
    }
  }
}

export function init() {
  document.querySelectorAll("[data-hbsptform]").forEach((el) => {
    new HubspotForm(el);
  });
}
